import type { Ref } from 'vue';
import { computed } from 'vue';

import type { IContextQueryResult } from '@modules/core/services/query/types';
import type { ITableDataResponse, ITableState } from '@modules/tables/types';
import { AFFILIATES_APPROVED_PERMISSIONS } from '@modules/affiliates-approved/constants';
import { useRestClient } from '@modules/core/services/api';
import { useContextQuery } from '@modules/core/services/query';
import { keepPreviousData } from '@tanstack/vue-query';

import type { IAffiliateTrackersListRecord } from '../types';
import { AFFILIATE_TRACKERS_SETTINGS_LIST_API_URL, AFFILIATE_TRACKERS_SETTINGS_LIST_QUERY } from '../constants';

export default function useAffiliateTrackersListQuery(
  tableState: Ref<ITableState>,
  id: Ref<number | undefined>,
  enabled: Ref<boolean>,
): IContextQueryResult<
    ITableDataResponse<IAffiliateTrackersListRecord>
  > {
  const { fetchPost } = useRestClient();

  return useContextQuery<ITableDataResponse<IAffiliateTrackersListRecord>>({
    queryKey: [AFFILIATE_TRACKERS_SETTINGS_LIST_QUERY, tableState, id],
    queryFn: ({ signal }) => fetchPost<ITableDataResponse<IAffiliateTrackersListRecord>>(
      AFFILIATE_TRACKERS_SETTINGS_LIST_API_URL,
      tableState.value,
      {
        signal,
        permission: AFFILIATES_APPROVED_PERMISSIONS.AFFILIATES_SHOW,
        urlParams: {
          id: id.value,
        },
      },
    ),
    placeholderData: keepPreviousData,
    enabled: computed(() => enabled.value && !!id.value),
  });
}
